'use client'

import { Heading } from '@graftcode/design-system'

import { LEARNING_PATHS } from '@/modules/academy/academy.const'
import { LEARNING_PATHS_SECTION_TEST_IDS } from '@/shared/academy-test-ids.const'

import { LearningPathCard } from './components/LearningPathCard'

import styles from './LearningPathsSection.module.scss'

export function LearningPathsSection() {
  return (
    <div className={styles.learningSection} data-testid={LEARNING_PATHS_SECTION_TEST_IDS.root}>
      <Heading className={styles.sectionTitle} type="h2">
        Learning paths
      </Heading>
      <div className={styles.learningPathsList}>
        {LEARNING_PATHS.map((path) => (
          <LearningPathCard key={path.id} path={path} />
        ))}
      </div>
    </div>
  )
}
